/* cart-count.js — instantly keep the header cart count in sync */
(() => {

  const updateBadge = (count) => {
    const elemental = document.querySelector('.tcc-count');
    let currentText = Number(elemental.textContent);
    currentText++;
    elemental.textContent = currentText;
  };

  const refreshFromCart = (event) => {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => updateBadge(cart.item_count))
      .catch(() => { /* no-op */ });
  }


  // Also respond to common theme events
   document.addEventListener('custom:cart:updated', refreshFromCart);
})();
